var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-box"},[_c('i',{staticClass:"fa fa-check-square-o stacked-icon checkbox"}),_c('font-awesome-icon',{staticClass:"stacked-icon users",attrs:{"icon":"user-friends"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }